<template>
    <rkm-form
        ref="RkmForm"
        show-legend
    >
        <rkm-overlay :show="loading">
            <rkm-row>
                <rkm-col cols="12">
                    <rkm-form-input
                        :validations="validations.nome"
                        disabled
                        label="Nome"
                        v-model="model.nome"
                    />
                </rkm-col>
            </rkm-row>

            <rkm-row>
                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.empresas"
                        :validations="validations.empresa"
                        label="Empresa"
                        show-default-option
                        v-model="model.empresa_id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-select
                        :options="form.ramos_atividade"
                        :validations="validations.ramo_atividade"
                        label="Ramo de atividade"
                        show-default-option
                        v-model="model.ramo_atividade_id"
                    />
                </rkm-col>

                <rkm-col cols="4">
                    <rkm-form-input
                        disabled
                        :validations="validations.versao"
                        label="Versão"
                        v-model="model.versao"
                    />
                </rkm-col>
            </rkm-row>
        </rkm-overlay>
    </rkm-form>
</template>

<script>
// Mixins.
import {error} from '@/mixins'

// Vuex.
import {mapActions, mapGetters} from 'vuex'

export default {
    computed: {
        ...mapGetters(['getLoading']),
        loading() {
            return this.getLoading('cadastro-sistema-form')
        },
        validations() {
            return {
                empresa: {required: true},
                ramo_atividade: {required: true},
                nome: {
                    required: true,
                    min: 3,
                    max: 100,
                },
                versao: {
                    required: true,
                    min: 5,
                    max: 100,
                    regex: /^\d+\.\d+\.\d+$/,
                },
            }
        },
    },
    data: () => ({
        form: {
            empresas: [],
            ramos_atividade: [],
        },
        model: {
            empresa_id: null,
            ramo_atividade_id: null,
            nome: null,
            versao: null,
        },
    }),
    inject: ['repositories'],
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        load() {
            if (this.id) {
                this.setLoading('cadastro-sistema-form')

                this.repositories.cadastro.sistema.edit(this.id)
                    .then(({data}) => {
                        this.form = data.form
                        this.model = data.model
                    })
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-sistema-form'))
            } else {
                this.repositories.cadastro.sistema.create()
                    .then(({data}) => this.form = data.form)
                    .catch(this.handleError)
                    .finally(() => this.unsetLoading('cadastro-sistema-form'))
            }
        },
        save() {
            this.$refs.RkmForm.validate()
                .then(validated => {
                    if (validated) {
                        this.setLoading('cadastro-sistema-form')

                        const request = {...this.model}

                        if (this.id) {
                            this.repositories.cadastro.sistema.update(request, this.id)
                                .then(({data}) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-sistema-form'))
                        } else {
                            this.repositories.cadastro.sistema.store(request)
                                .then(({data}) => this.$emit('save', data))
                                .catch(this.handleError)
                                .finally(() => this.unsetLoading('cadastro-sistema-form'))
                        }
                    }
                })
        },
    },
    mixins: [error],
    mounted() {
        this.load()
    },
    props: {
        id: {type: Number},
    },
}
</script>